import { DispatchBoardQueueStatus } from "app/data/city-delivery/dispatch-board/models";
import React, { memo } from "react";
import NumberFormat from "react-number-format";
import DispatchQueueLoadStatus from "../../dispatch-queue-load-status/dispatchQueueLoadStatus";

export interface cityDeliveryDispatchWorkflowLoadSummaryProps {
    picklistNumber?: number;
    manifestNumber: number;
    status: DispatchBoardQueueStatus;
    routeName: string;
    door: string;
    stops: number;
    probills: number;
    pieces: number;
    weight: number;
}

const cityDeliveryDispatchWorkflowLoadSummary: React.FC<cityDeliveryDispatchWorkflowLoadSummaryProps> = memo((props) => {

    const getFormattedProgressMatric = (value?: number) => {
        if (!value) return "0";
        return <NumberFormat
            value={value}
            decimalScale={2}
            displayType={"text"}
            thousandSeparator={","}
            prefix={""}
        />
    }

    return (
        <div className="city-delivery-dispatch-workflow__load-summary">
            <div className="city-delivery-dispatch-workflow__load-summary__row">
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Picklist Number
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {(props.picklistNumber) ? props.picklistNumber : "--"}
                    </div>

                </div>
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Manifest Number
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {(props.manifestNumber) ? props.manifestNumber : "--"}
                    </div>

                </div>
            </div>
            <div className="city-delivery-dispatch-workflow__load-summary__row">
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Door
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {(props.door) ? props.door : "--"}
                    </div>

                </div>
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Route Name
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {(props.routeName) ? props.routeName : "--"}
                    </div>

                </div>
            </div>
            <div className="city-delivery-dispatch-workflow__load-summary__row">
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Status
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                    <DispatchQueueLoadStatus dispatchLoadStatus={props.status}/>
                    </div>

                </div>
            </div>
            <div className="city-delivery-dispatch-workflow__load-summary__divider"></div>
            <div className="city-delivery-dispatch-workflow__load-summary__row">
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Probills
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {(props.probills) ? props.probills : "--"}
                    </div>

                </div>
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">

                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Pieces
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {(props.pieces) ? props.pieces : "--"}
                    </div>

                </div>

            </div>
            <div className="city-delivery-dispatch-workflow__load-summary__row">
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Weight
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {getFormattedProgressMatric(props.weight)} lbs
                    </div>
                </div>
                <div className="city-delivery-dispatch-workflow__load-summary__row__column">
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__key">
                        Stops
                    </div>
                    <div className="city-delivery-dispatch-workflow__load-summary__row__column__value">
                        {getFormattedProgressMatric(props.stops)}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default cityDeliveryDispatchWorkflowLoadSummary;
